import { handleAction } from 'redux-actions';

import * as actions from '../actions';

const InitialState = null;

export const deviceIdReducer = handleAction(
  actions.setDeviceId,
  (state, { payload: deviceId }) => deviceId,
  InitialState
);
